import { Component, input } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-uploading-toast',
  standalone: true,
  imports: [ToastModule, ProgressBarModule],
  templateUrl: './uploading-toast.component.html',
  styleUrl: './uploading-toast.component.scss'
})
export class UploadingToastComponent {
  progress = input<number>();
}
